import { RefObject, useEffect } from 'react';
import getHeightOfMinutes from '../helpers/getHeightOfMinutes';

const MINUTES_VISIBLE_BEFORE = 15;

const useScrollToMinAvailableTime = (
    scrollRef: RefObject<HTMLDivElement>,
    minAvailableStartAt?: number,
) => {
    useEffect(
        () => {
            const scrollElement = scrollRef.current;
            if (!scrollElement || minAvailableStartAt === undefined) {
                return;
            }

            const minutes = (minAvailableStartAt / 60) - MINUTES_VISIBLE_BEFORE;
            scrollElement.scrollTop = Math.max(0, getHeightOfMinutes(minutes));
        },
        [minAvailableStartAt, scrollRef],
    );
};

export default useScrollToMinAvailableTime;
